import { render, staticRenderFns } from "./PayslipSetting.vue?vue&type=template&id=ab81aedc&"
import script from "./PayslipSetting.vue?vue&type=script&lang=js&"
export * from "./PayslipSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports